export const RECAPTCHA_KEY = "6LfMuaMrAAAAAPzXh4YsrDB6QCOQpg4HN6i5ztdx";
